import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { apiTasks } from 'services/tasks/api';
import { taskWriteErrorMessage } from 'services/tasks/apiError';
import { pushNotice } from './slice';

type TaskWriteRejectedAction = {
  meta: {
    aborted: boolean;
    condition: boolean;
  };
  payload?: unknown;
  type: string;
};

const isTaskWriteRejected = (
  action: { type: string },
): action is TaskWriteRejectedAction => isAnyOf(
  apiTasks.endpoints.addTask.matchRejected,
  apiTasks.endpoints.deleteManyTasks.matchRejected,
  apiTasks.endpoints.deleteTask.matchRejected,
  apiTasks.endpoints.patchManyTasks.matchRejected,
  apiTasks.endpoints.patchTask.matchRejected,
  apiTasks.endpoints.updateTask.matchRejected,
)(action);

const taskErrorListener = createListenerMiddleware();

taskErrorListener.startListening({
  predicate: isTaskWriteRejected,
  effect: (action, api) => {
    if (action.meta.aborted || action.meta.condition) {
      return;
    }
    api.dispatch(pushNotice(taskWriteErrorMessage(action.payload)));
  },
});

export default taskErrorListener.middleware;
